import React, {FC, useState} from 'react';
import FontBody1 from '../../../../../components/fonts/font-body1/font-body1';
import {FONT_COLOR, FONT_VARIANT} from '../../../../../components/fonts/font-props';
import {Input} from '../../../../../components/inputs/input/input';
import Card from '../../../../../components/layouts/card/card';
import customizationStore from '../../../../../stores/customizations/customization-store';
import {FormField} from '../../../../../components/form-field/form-field';
import {BORDER_RADIUS_LIMITS_MAP, PORTAL_POSITION} from '../../../../../models/User';
import portal_position_left_preview from '../../../../../images/previews/portal-position/left.svg';
import portal_position_right_preview from '../../../../../images/previews/portal-position/right.svg';
import portal_position_center_preview from '../../../../../images/previews/portal-position/center.svg';
import margins_preview from '../../../../../images/previews/margins.svg';
import ControlGroupWithPreview from '../../../../../components/layouts/control-group-with-preview/control-group-with-preview';
import ListLayout from '../../../../../components/layouts/list-layout/list-layout';
import {FormFieldLine} from '../../../../../components/form-field-line/form-field-line';
import Hr from '../../../../../components/hr/hr';
import {observer} from 'mobx-react';
import PortalPositionSelect from './portal-position-select/portal-position-select';
import ColorPickerInput from '../../color-picker-input/color-picker-input';

const GeneralCard: FC = observer(() => {
	const [isExpanded, setIsExpanded] = useState(false);
	const classicCustomizationStore = customizationStore.getClassicStore();
	const activeCustomizationStore = customizationStore.getSelectedStore();

	const getPortalPositionPreview = () => {
		switch (classicCustomizationStore.portalPosition) {
			case PORTAL_POSITION.CENTER:
				return portal_position_center_preview;
			case PORTAL_POSITION.LEFT:
				return portal_position_left_preview;
			case PORTAL_POSITION.RIGHT:
				return portal_position_right_preview;
		}
	}

	return (
		<Card
			toolbar={{
				title: <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>General</FontBody1>
			}}
			isExpanded={isExpanded}
			expandCallback={setIsExpanded}
		>
			<FormField
				label='Layout'
				instructions='Customize your portal layout'
				children={null}
			/>
			<ControlGroupWithPreview
				hasTopBorder={false}
				gridStyle={{childrenWidth: {width: 1}, previewWidth: {width: 1}}}
				preview={<div className="preview"><img src={getPortalPositionPreview()} alt="" /></div>}
			>
				<ListLayout>
					<FormFieldLine
						label='Portal position on page'
					>
						<PortalPositionSelect
							value={classicCustomizationStore.portalPosition}
							onChange={(value) => classicCustomizationStore.setPortalPosition(value)}
						/>
					</FormFieldLine>
					<FormFieldLine label='Portal border radius'>
						<Input
							type="number"
							value={activeCustomizationStore.portalBorderRadius}
							onChange={activeCustomizationStore.setPortalBorderRadius}
							min={BORDER_RADIUS_LIMITS_MAP['portal_border_radius'].min}
							max={BORDER_RADIUS_LIMITS_MAP['portal_border_radius'].max}
							adornment="px"
						/>
					</FormFieldLine>
					<FormFieldLine label='Button border radius'>
						<Input
							type="number"
							value={activeCustomizationStore.buttonBorderRadius}
							onChange={activeCustomizationStore.setButtonBorderRadius}
							min={BORDER_RADIUS_LIMITS_MAP['button_border_radius'].min}
							max={BORDER_RADIUS_LIMITS_MAP['button_border_radius'].max}
							adornment="px"
						/>
					</FormFieldLine>
					<FormFieldLine label='Elements border radius'>
						<Input
							type="number"
							value={activeCustomizationStore.elementsBorderRadius}
							onChange={activeCustomizationStore.setElementsBorderRadius}
							min={BORDER_RADIUS_LIMITS_MAP['elements_border_radius'].min}
							max={BORDER_RADIUS_LIMITS_MAP['elements_border_radius'].max}
							adornment="px"
						/>
					</FormFieldLine>
					<FormFieldLine label="Button section background">
						<ColorPickerInput
							value={activeCustomizationStore.footerBackgroundColor}
							onChange={activeCustomizationStore.setFooterBackgroundColor}
						/>
					</FormFieldLine>
					<FormFieldLine label="Button section opacity">
						<Input
							type="number"
							min={0} max={100}
							value={classicCustomizationStore.footerBackgroundOpacity}
							onChange={classicCustomizationStore.setFooterBackgroundOpacity}
						/>
					</FormFieldLine>
				</ListLayout>
			</ControlGroupWithPreview>

			<Hr/>

			<FormField
				label='Margin'
				instructions='Customize the amount of space around the portal.'
				children={null}
			/>
			<ControlGroupWithPreview
				hasTopBorder={false}
				gridStyle={{childrenWidth: {width: 1}, previewWidth: {width: 1}}}
				preview={<div className="preview"><img src={margins_preview} alt="" /></div>}
			>
				<ListLayout>
					<FormFieldLine label='Container margins'>
						<Input type="number" value={classicCustomizationStore.containerMargins} onChange={classicCustomizationStore.setContainerMargins} adornment="px"/>
					</FormFieldLine>
					<FormFieldLine label='Top margin'>
						<Input type="number" value={classicCustomizationStore.topMargin} onChange={classicCustomizationStore.setTopMargin} adornment="px"/>
					</FormFieldLine>
					<FormFieldLine label='Bottom margin'>
						<Input type="number" value={classicCustomizationStore.bottomMargin} onChange={classicCustomizationStore.setBottomMargin} adornment="px"/>
					</FormFieldLine>
				</ListLayout>
			</ControlGroupWithPreview>

		</Card>
	)
})

export default GeneralCard
